export default theme => ({
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
  },

  icon: {
    fontSize: theme.typography.pxToRem(68),
  },

  iconStatusSuccess: {
    color: theme.palette.common.success,
  },

  iconStatusWarning: {
    color: theme.palette.common.warning,
  },

  iconStatusError: {
    color: theme.palette.common.danger,
  },

  title: {
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(28),
    fontWeight: theme.typography.fontWeightMedium,
    [theme.breakpoints.down(426)]: {
      fontSize: theme.typography.pxToRem(24),
    }
  },

  message: {
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(17),
    color: theme.palette.grey.eccoGrey,
    [theme.breakpoints.down(426)]: {
      fontSize: theme.typography.pxToRem(14),
    }
  },
});